const smallDesktop = window.matchMedia('(min-width: 64rem');
const largeDesktop = window.matchMedia('(min-width: 75rem');

export { smallDesktop, largeDesktop };
